import './App.css';
import Items from "./JS/Items"
import List from "./JS/list"


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Items />
        <List />
      </header>
    </div>
  );
}

export default App;
